<template>
  <div class="publicBoxs">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <template v-if="stSplit">
        <el-row>
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="整套服务商品">{{serviceRow.serviceName}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <div class="seize"></div>
          </el-col>
          <el-col :span="20">
            <el-col :span="13">
              <el-form-item label="拆分" prop="knotCount" label-width="100px">
                <el-input v-model="form.knotCount" style="width:90px"></el-input>&nbsp;&nbsp;套为
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item prop="unitCount" label-width="0">
                <el-input v-model="form.unitCount" style="width:90px"></el-input>&nbsp;&nbsp;次
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="申请员工">{{$store.state.userInfo.staffName}}</el-form-item>
            <el-form-item label="申请原因" prop="applyRemark">
              <el-input type="textarea" v-model="form.applyRemark" style="height:110px;" placeholder="必填项，最多30个中文字符长度" resize="none"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template v-else-if="memberNmu">
        <el-row>
          <el-col :span="2">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="会员名称">{{serviceArrs[0].memberName?serviceArrs[0].memberName:''}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="会员手机">{{serviceArrs[0].memeberPhone?serviceArrs[0].memeberPhone:''}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="选择服务" prop="goodsId">
            <el-select v-model="form.goodsId" placeholder="请选择服务" style="width:120px;">
              <el-option v-for="(item,index) in serviceArrs" :key="index" :label="item.goodsName" :value="item.goodsId"></el-option>
            </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17" class="disLineAdth">
            <el-form-item label="调整库存" prop="changeType">
              <el-select v-model="form.changeType" placeholder="请选择增减" style="width:120px;">
                <el-option label="增加" value="1"></el-option>
                <el-option label="减少" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="changeCount" label-width="0">
              <el-input v-model="form.changeCount" style="width:90px"></el-input>&nbsp;&nbsp;次
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="调整原因" prop="changeRemarks">
              <el-input type="textarea" v-model="form.changeRemarks" style="height:110px;" placeholder="必填项，最多30个中文字符长度" resize="none"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template v-else>
        <el-row>
          <el-col :span="2">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="商品编号">{{serviceRow.serviceCode}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="商品名称">{{serviceRow.serviceName}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="选择库存" prop="inventoryType" v-if="serviceRow.serviceType == 2" required>
              <el-select v-model="form.inventoryType">
                <el-option label="现有库存" :value="4"></el-option>
                <el-option label="寄存库存" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17" class="disLineAdth">
            <el-form-item label="调整库存" prop="changeType">
              <el-select v-model="form.changeType" placeholder="请选择增减" style="width:120px;">
                <el-option label="增加" value="1"></el-option>
                <el-option label="减少" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="changeCount" label-width="0">
              <el-input v-model="form.changeCount" style="width:90px"></el-input>&nbsp;&nbsp;{{serviceRow.serviceType==1?'次':(serviceRow.serviceType==2?'套':'件')}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item label="调整原因" prop="changeRemarks">
              <el-input type="textarea" v-model="form.changeRemarks" style="height:110px;" placeholder="必填项，最多30个中文字符长度" resize="none"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <el-row class="btnOptions">
        <el-button class="darkBtn" @click="resetData">取消</el-button>
        <el-button class="redBtn" v-if="!memberNmu" @click="onSubmit">确定</el-button>
        <el-button class="redBtn" v-if="memberNmu" @click="onSubmitMem">确定</el-button>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import {adjustInventory, storeServiceBreakUp, updatrMemberRemainingServicesNumber} from "@/api";
export default {
  props: ["serviceRow", "stSplit","memberNmu","serviceArr"],
  data() {
    const isvalidateNumber = (rule, value, callback) => {
      if (/^[0-9]*$/.test(value) == false) {
         callback(new Error("请输入数字"));
          this.form.changeCount = '';
      } else {
        callback();
      }
    };
    return {
      form: {
        changeCount: "",
        changeType:'',
        inventoryType:4,
        changeRemarks:'',
        knotCount:'',
        unitCount:'',
        applyRemark:'',
        goodsId:''
      },
      rules: {
        goodsId:[
          {required: true,message: "请选择服务",trigger: "change"}
        ],
        changeType:[
          {required: true,message: "请选择增减",trigger: "change"}
        ],
        knotCount:[
          {required: true,message: "请输入拆分套数",trigger: "blur"}
        ],
        unitCount:[
          {required: true,message: "请输入生成次数",trigger: "blur"}
        ],
        applyRemark: [
          {required: true, message: "请输入申请原因", trigger: "blur" },
          {min: 0,max: 30,message: "最多30 个中文字符长度",trigger: "blur"}
        ],
        changeCount:[
          {required: true,message: "请输入调整库存数量",trigger: "blur"},
          {validator: isvalidateNumber,trigger: "blur"}
        ],
        changeRemarks: [
          {required: true, message: "请输入原因", trigger: "blur" },
          {min: 0,max: 30,message: "最多30 个中文字符长度",trigger: "blur"}
        ],
      },
      serviceArrs:this.serviceArr
    };
  },
  created() {
    // console.log(this.serviceArr)
  },
  methods: {
    onSubmitMem() {//会员调整
      this.$refs.form.validate(valid => {
        if (valid) {
          if(this.form.changeType != 1){
            this.form.changeCount = '-' + this.form.changeCount;
          }
          let postDatas = {}
          this.serviceArrs.forEach(item => {
            if(this.form.goodsId && this.form.goodsId == item.goodsId){
              postDatas = {
                goodsId:item.goodsId,
                goodsName:item.goodsName,
                changeSum: this.form.changeCount,
                changeType:this.form.changeType,
                chageRemark:this.form.changeRemarks,
                orderId:item.orderId,
                memberId:item.memberId,
                memberName:item.memberName,
                memeberPhone:item.memeberPhone,
                residueFrequency:item.residueFrequency,
                orderGoodsId:item.orderGoodsId,
                orderGoodsDetailsId:item.id,
                technicianIdStore:this.$store.state.userInfo.staffId,
                technicianNameStore:this.$store.state.userInfo.staffName
              }
            }
          });
          updatrMemberRemainingServicesNumber(postDatas).then(res => {
            this.resetData();
            this.$message({
              type: res.code == 1 ? 'success':"error",
              message: res.msg
            });
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onSubmit() {//   确定
      this.$refs.form.validate(valid => {
        if (valid) {
          if(this.stSplit){
            let postDatas = {
              serviceId:this.serviceRow.id,
              unitCount:this.form.unitCount,
              knotCount:this.form.knotCount,
              applyRemark:this.form.applyRemark,
              createId:this.$store.state.userInfo.staffId,
              createName:this.$store.state.userInfo.staffName,
              serviceType:this.serviceRow.serviceType
            }
            storeServiceBreakUp(postDatas).then(res => {
              this.resetData();
              this.$message({
                type: res.code == 1 ? 'success':"error",
                message: res.msg
              });
            });
          }else{
            if(this.form.changeType != 1){
              this.form.changeCount = '-' + this.form.changeCount;
            };
            let postData = {
              serviceId:this.serviceRow.id,
              productNo:this.serviceRow.serviceCode,
              productName:this.serviceRow.serviceName,
              storeCode:this.$store.state.userInfo.storeCode,
              createId:this.$store.state.userInfo.staffId,
              createName:this.$store.state.userInfo.staffName,
              serviceType:this.serviceRow.serviceType,
              changeCount: this.form.changeCount,
              changeType:this.form.changeType,
              inventoryType:this.form.inventoryType,
              changeRemarks:this.form.changeRemarks,
            }
            adjustInventory(postData).then(res => {
              this.resetData();
              this.$message({
                type: res.code == 1 ? 'success':"error",
                message: res.msg
              });
            });
          }

        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetData() {//   取消
      this.form = this.$options.data().form;
      this.$refs.form.clearValidate();
      this.$emit("closeDialog", false);
    },
  }
};
</script>
<style lang="less" scoped>
.publicBoxs {
  .seize {
    height: 20px;
  }
  .disLineAdth{
    .el-form-item{
      float: left;
      margin-right: 10px
    }
  }
  .btnOptions {
    text-align: center;
    .el-button {
      width: 105px;
      height: 38px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/businessManagementCenter/publicBox.vue